import { render, staticRenderFns } from "./ymqc_list.vue?vue&type=template&id=edd531c8&scoped=true&"
import script from "./ymqc_list.vue?vue&type=script&lang=js&"
export * from "./ymqc_list.vue?vue&type=script&lang=js&"
import style0 from "./ymqc_list.vue?vue&type=style&index=0&id=edd531c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd531c8",
  null
  
)

export default component.exports